import React from 'react'
import PropTypes from 'prop-types'
import Authorization from '../../../security/component/auth/AuthorizationContainer'
import { ROLE_EMPLOYEE } from '../../../security/state/auth/const'
import PhysicianAndSupplier from './PhysicianAndSupplier'
import TraySize from './TraySize'
import TreatmentQuotationContainer from '../../../treatment/component/quotation/TreatmentQuotationContainer'
import TreatmentExecution from './TreatmentExecution'
import TreatmentFeedback from './TreatmentFeedback'
import AnamnesisList from '../../../anamnesis/component/list/AnamnesisListContainer'
import IPRInstructions from '../../../treatment/component/plan/IPRInstructions'
import { TAB_MEDICAL } from '../../state/detail/const'
import PatientIPRWishesWidgetContainer from "../../../process/component/task-widget/PatientIPRWishesWidgetContainer";


const TabMedical = (props) => {
    const { tab, customer } = props;
    if (tab !== TAB_MEDICAL) {
        return null
    }
    return (

        <React.Fragment>


            <Authorization requiredRole={ROLE_EMPLOYEE}>
                <PhysicianAndSupplier {...props}/>
                <TraySize {...props} readOnly={true}/>
            </Authorization>

            <TreatmentFeedback customer={customer}/>

            <TreatmentExecution customer={customer}/>

            <TreatmentQuotationContainer onlyDisplay={true} validationMessageList={[]}/>

            <AnamnesisList customer={customer}/>

            <PatientIPRWishesWidgetContainer readOnly={true} customer={customer}/>

            {customer.treatmentPlanList.length !== 0 && (
                <IPRInstructions
                    readOnly={true}
                    isWidget={false}
                    changeIPRInstruction={() => {
                    }}
                    saveTreatmentPlan={() => {
                    }}
                    context={{}}
                    treatmentPlan={customer.treatmentPlanList[0]}
                    isIPRProviderStore={true}
                />
            )}


        </React.Fragment>

    )
}

TabMedical.propTypes = {
    tab: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
}

export default TabMedical



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TabMedical.js